import 'jquery-ui-dist/jquery-ui';

import helpers from '../util/helpers';

export default {
    init($) {

      let playing = false;

      function initAudioPlayer(player) {
        if (player.readyState > 2) {
            var i = player.id;
            var playerId = i.replace(/(player)/gm, "");
            $("#maxTime" + playerId).html(helpers.timeFormat(player.duration));
            $(player).removeClass("notready");
        } else {
            $(player).addClass("notready");
        }
      }

      $(".eazy-play").on("click", function () {

        const playerId = $(this).data("id");
        const audioEl = $("body").find("#player" + playerId);

        $('audio').each((i, el) => {
          if(audioEl[0].id != el.id) {
            const $playButton = $(el).closest('.episode').find('.eazy-play');
            el.pause();
            $playButton.addClass('play').removeClass('pause');
          }
        });

        if ($(this).hasClass("play")) {
          $(this).addClass('pause');
          $(this).removeClass('play');
          audioEl[0].play();
          playing = true;
          audioEl[0].addEventListener("timeupdate", function() {
            const $seekDot = $("#seek"+playerId+" .eazy-seek_dot")
            $("#curTime" + playerId).html(helpers.timeFormat(audioEl[0].currentTime));

            const seekTime = parseInt(audioEl[0].currentTime, 10);
            const seekPerc = seekTime / parseInt(audioEl[0].duration, 10) * 100;
            $seekDot.css("left","" + seekPerc + "%");

              if (audioEl[0].currentTime == audioEl[0].duration) {
                $seekDot.css("left", "0");
                $('.eazy-play[data-id="'+playerId+'"]').toggleClass("fa-play fa-pause");
                playing = false;
              }
          });
        } else {
          $(this).addClass('play');
          $(this).removeClass('pause');
          audioEl[0].pause();
          playing = false;
        }
      });

      $(".eazy-seek_dot").draggable({
        axis: "x",
        containment: "parent",
        start: event=> {
          const audioEl = $(event.currentTarget).closest('.episode').find("audio");
          if(playing) {
            audioEl[0].pause();
          }
        },
        stop: event => {
          const audioEl = $(event.target).closest('.episode').find("audio");
          if(playing) {
            audioEl[0].play();
          }
        },
        drag: (event, ui) => {
          const $episode = $(event.target).closest('.episode');
          const audioEl = $episode.find("audio");
          const playerId = $episode.find('[data-id]').data('id');
          audioEl[0].currentTime = Math.floor(audioEl[0].duration / $(event.target).parent().width() * ui.position.left);
          $("#curTime" + playerId).html(helpers.timeFormat(audioEl[0].currentTime));
        }
      });

      $(document).ready(function() {
        const allPlayers = $("body").find("audio");
        $.each(allPlayers, function() {
          initAudioPlayer(this);
        });

        setTimeout(function() {
          const notreadyPlayers = $("body").find("audio.notready");
          $.each(notreadyPlayers, function() {
            initAudioPlayer(this);
          });
        }, 3000);
      });

      const storage = window.localStorage;
      const lang = 'LANG';

      const en = event => {
        event.preventDefault();
        event.stopPropagation();
        storage.setItem(lang, '#english');
        $('a.translator-language-en').trigger('click');
        $('.menu-item-has-children').html('<a href="#english">English</a><ul class="sub-menu"><li id="menu-item-1017" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-1017"><a href="#spanish">Español</a></li></ul>');
        $('a[href=#spanish]').off().on('click', event => {
          sp(event);
        });
        $('a[href=#english]').off().on('click', event => {
          en(event);
        });
      };

      const sp = event => {
        event.preventDefault();
        event.stopPropagation();
        storage.setItem(lang, '#spanish');
        $('a.translator-language-es').trigger('click');
        $('.menu-item-has-children').html('<a href="#spanish">Español</a><ul class="sub-menu"><li id="menu-item-1017" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-1017"><a href="#english">English</a></li></ul>');
        $('a[href=#spanish]').off().on('click', event => {
          sp(event);
        });
        $('a[href=#english]').off().on('click', event => {
          en(event);
        });
      };

      $('a[href=#english]').on('click', event => {
        en(event);
      });
      $('a[href=#spanish]').on('click', event => {
        sp(event);
      });

  },
  finalize($) {
    const storage = window.localStorage;
    const lang = 'LANG';
    if(storage.getItem(lang) && ['#english', '#spanish'].includes(storage.getItem(lang))) {
      $('a[href='+storage.getItem(lang)+']').trigger('click');
    } else if(['#english', '#spanish'].includes(window.location.hash)) {
      $('a[href='+window.location.hash+']').trigger('click');
    }

  }
}
